import { IExportPlugin, PluginType } from '@/version-types';
import { Active } from './active';
import { CustomLayer } from './custom-layer';
import { Font } from './font';
import { Result } from './result';
import { ShortcutMenu } from './shortcut-menu';
import { Stage } from './stage';
import { StageHistory } from './stage-history';
import { Tip } from './tip';

export { Active } from './active';
export { CustomLayer } from './custom-layer';
export { Font } from './font';
export { Result } from './result';
export { ShortcutMenu } from './shortcut-menu';
export { Stage } from './stage';
export { Tip } from './tip';

export const frameworkEditorPlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.EXTENSION,
    name: 'framework-editor',
    createInstance({ identity }) {
        return [
            { key: 'Active', value: new Active(identity) },
            { key: 'CustomLayer', value: new CustomLayer(identity) },
            { key: 'Font', value: new Font(identity) },
            { key: 'Result', value: new Result(identity) },
            { key: 'ShortcutMenu', value: new ShortcutMenu(identity) },
            { key: 'Stage', value: new Stage(identity) },
            { key: 'Tip', value: new Tip(identity) },
        ];
    },

    createHistory({ identity }) {
        return [new StageHistory(identity)];
    },
};
